// Regras puras dos templates de stories no painel (sem React, sem rede):
// validar o arquivo, montar o caminho no bucket, calcular o recorte 9:16 e
// traduzir erros das RPCs.

import { STORY_HEIGHT, STORY_TEMPLATE_MAX_BYTES, STORY_TEMPLATE_MIME_TYPES, STORY_WIDTH } from "@lucralink/shared";
import { mapRpcError } from "@/lib/rpc-error";

export const STORY_BUCKET = "story-assets";
const RATIO = STORY_WIDTH / STORY_HEIGHT;
export const MAX_ZOOM = 4;

export type FileCheck = { ok: true } | { ok: false; message: string };

export function checkTemplateFile(file: { type: string; size: number }): FileCheck {
  if (!(STORY_TEMPLATE_MIME_TYPES as readonly string[]).includes(file.type)) {
    return { ok: false, message: "Use uma imagem PNG, JPEG ou WebP." };
  }
  if (file.size > STORY_TEMPLATE_MAX_BYTES) return { ok: false, message: "A imagem passa de 5 MB." };
  return { ok: true };
}

export function templatePathFor(tenantId: string, id: string): string {
  return `${tenantId}/templates/${id}.jpg`;
}

export interface CropRect {
  readonly sx: number;
  readonly sy: number;
  readonly sw: number;
  readonly sh: number;
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/** Area da imagem original que vira o story 9:16. zoom >= 1 aproxima;
 *  offsetX/offsetY em -1..1 movem o recorte dentro da folga disponivel. */
export function cropRect(width: number, height: number, zoom: number, offsetX: number, offsetY: number): CropRect {
  const z = clamp(Number.isFinite(zoom) ? zoom : 1, 1, MAX_ZOOM);
  const baseW = width / height > RATIO ? height * RATIO : width;
  const sw = baseW / z;
  const sh = sw / RATIO;
  const slackX = (width - sw) / 2;
  const slackY = (height - sh) / 2;
  const sx = slackX + clamp(offsetX, -1, 1) * slackX;
  const sy = slackY + clamp(offsetY, -1, 1) * slackY;
  return { sx, sy, sw, sh };
}

const ERRORS: Readonly<Record<string, string>> = {
  watermark_requires_pro: "Templates próprios são do plano PRO.",
  story_custom_requires_pro: "Templates próprios são do plano PRO.",
  story_templates_limit_reached: "Limite de 10 templates próprios atingido. Apague um para enviar outro.",
  story_template_name_invalid: "Dê um nome de 1 a 60 caracteres.",
  story_render_rate_limited: "Muitos pedidos seguidos. Espere um minuto e tente de novo.",
  story_render_daily_limit: "Você atingiu o limite diário de stories do seu plano. Tente de novo amanhã.",
  link_not_owned: "Esse link não pertence à sua conta.",
  story_ref_invalid: "Template inválido ou apagado.",
};

export function storyErrorMessage(error: unknown): string {
  return mapRpcError(error, ERRORS, "Não foi possível concluir a ação do story.");
}
